import { IoStarSharp } from 'react-icons/io5'

const RatingStars = ({ rating, outOf = 5, size = 5 }: { rating: number; outOf?: number; size?: number }) => {
  if (rating <= 0 || rating > outOf) {
    return null
  }

  let fullStars = Math.floor(rating)
  const hasHalf = rating - fullStars >= 0.25 && rating - fullStars <= 0.75
  if (rating - fullStars > 0.75) {
    fullStars = Math.ceil(rating)
  }
  const emptyStars = outOf - fullStars - (hasHalf ? 1 : 0)

  return (
    <div className='flex items-center mb-0.5'>
      {[...Array(fullStars)].map((_, i) => (
        <IoStarSharp key={`full-${i}`} className={`size-${size} text-yellow-500`} />
      ))}
      {hasHalf && (
        <span className={`relative size-${size}`} key='half'>
          <IoStarSharp className={`size-${size} text-yellow-500 absolute left-0 top-0`} style={{ clipPath: 'inset(0 50% 0 0)' }} />
          <IoStarSharp
            className={`size-${size} text-zinc-300 dark:text-zinc-500 absolute left-0 top-0`}
            style={{ clipPath: 'inset(0 0 0 50%)' }}
          />
        </span>
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <IoStarSharp key={`empty-${i}`} className={`size-${size} text-zinc-300 dark:text-zinc-500`} />
      ))}
    </div>
  )
}

export default RatingStars
